<div class="bg-image" style="font-family: 'SolaimanLipi_bold', 'Ubuntu' !important; font-size: 100%;">
  <div class="container" style="padding-top: 30px; padding-bottom: 30px">
    <div class="row">
      <!-- Main Column -->
      <div class="col-md-8">
        <ng-container *ngFor="let data of reversedData; let i = index">
          <ng-container *ngFor="let item of data.ShowAttachments">
            <div class="row pdf-holder mb-3">

              <!-- Icon & Date -->
              <div class="col-xs-3 col-sm-3 text-center">
                <i class="fa fa-lg fa-file"></i><br />
                <span><small>{{ data.CurrentDate | date }}</small></span>
              </div>

              <!-- Document Title -->
              <div class="col-xs-6 col-sm-6">
                <a class="notice-link" href="{{ item.FilePath }}" target="_blank">
                  <h6 style="margin-top: 10px; margin-bottom: -10px;">{{ data.TitleEn }}</h6>
                </a>
              </div>

              <!-- Download Button -->
              <div class="col-xs-3 col-sm-3 text-center">
                <a href="{{ item.FilePath }}" class="cloud-downloader">
                  <i class="fa fa-cloud-download" aria-hidden="true"></i><br />
                  <small>Download</small>
                </a>
              </div>

            </div>
          </ng-container>
        </ng-container>
      </div>

      <!-- Aside Column -->
      <div class="col-md-4">
        <app-aside></app-aside>
      </div>
    </div>
  </div>
</div>
